import Multiselect from "vue-multiselect";
import axios from 'axios';
import debounce from "lodash/debounce";

export const covidSearchMixin = {
    components: {
        Multiselect
    },
    data: {
        apiResults: [],
        show: false,
        countries: []
    },
    beforeMount: function () {
        var lsdata = window.localStorage.getItem('comparatorLS');
        if (lsdata) {
            this.countries = JSON.parse(lsdata);
        }
    },
    computed: {
        comparatorLength: function () {
            return this.countries.length;
        },
        results: function () {
            var results = [];
            for (var i = 0; i < this.apiResults.length; i++) {
                var apiResult = this.apiResults[i];
                for (var j = 0; j < this.countries.length; j++) {
                    apiResult.compared = apiResult.slug == this.countries[j].slug;
                    if (apiResult.compared) {
                        break;
                    }
                }
                results.push(apiResult);
            }
            return results;
        },
        comparatorUrl: function () {
            var urlR = '/especial-covid-19/comparador';
            this.countries.forEach(function (element) {
                urlR += '/' + element.slug;
            });
            return urlR;
        }
    },
    methods: {
        toggleComparator: function () {
            this.show = !this.show;
        },
        removeItem: function (slug) {
            var idx = -1;
            for (var i = 0; i < this.countries.length; i++) {
                if (this.countries[i].slug == slug) {
                    idx = i;
                    break;
                }
            }
            if (idx > -1) {
                this.countries.splice(idx, 1);
                window.localStorage.setItem('comparatorLS', JSON.stringify(this.countries));
            }

        },
        autocomplete: debounce(function (topic) {
            if (topic) {
                var req = {
                    term: topic,
                };
                const _self = this;
                axios.get('/api/covid/ac', {
                    params: req
                }).then(function (response) {
                    _self.apiResults = response.data.items;
                }, function (response) {

                });
            }

        }, 200),
        close: function () {
            this.apiResults = [];
        },
        selectOpt: function (opt) {
            window.location.href = opt.relativeUrl;
        },
        addComparator: function (value) {
            value.compared = true;
            var countries = this.countries.slice(0, 3);
            var val = {
                idx: this.countries.length,
                spanishName: value.spanishName,
                slug: value.slug,
                flag: value.flag
            }
            countries.push(val);
            window.localStorage.setItem('comparatorLS', JSON.stringify(countries));
            this.countries = countries;
            this.show = true;
        },
        addItem: function (flag, slug, name) {
            this.addComparator({
                flag: flag,
                slug: slug,
                spanishName: name
            });
        },
        isActive: function (slug) {
            return this.countries.some(function (q) {
                return q.slug == slug
            });
        }
    }
};
export const covidComparatorMixin = {
    data: {
        comparatorResults: [],
        selValues: [],
        maxOptions: 4,
        color: [
            "#0071BC",
            "#39B54A",
            "#F7931E",
            "#ED1C24",
            "#93278F",
            "#ED1E79"
        ],
        urlBase: '/especial-covid-19/comparador'
    },
    created: function () {
        this.ls = new ComparerLS();
    },
    beforeMount: function () {
        if (window.selectedCountries) {
            this.selValues = selectedCountries;
            this.ls.setLS(this.selValues);
        } else {
            this.selValues = this.ls.getLS();
        }
    },
    methods: {
        autocompleteComparator: debounce(function (topic) {
            var _self = this;
            if (topic) {
                var req = {
                    term: topic,
                };

                axios.get('/api/covid/ac', {
                    params: req
                }).then(function (response) {
                    _self.comparatorResults = response.data.items;
                }, function (response) {

                });
            } else {
                _self.comparatorResults = [];
            }
        }, 200),
        getData: function () {
            var urlR = this.urlBase;
            this.selValues.forEach(function (element, index, array) {
                urlR += '/' + element.slug;
            });
            window.location.href = urlR;
        },
        onChange: function (value) {
            this.selValues = this.selValues.map(function (el, idx) {
                el.idx = idx
                return el;
            });
            const newls = this.selValues.map(function (el) {
                return {
                    idx: el.idx,
                    spanishName: el.spanishName,
                    slug: el.slug,
                    flag: el.flag
                };
            });
            this.ls.setLS(newls);
        }
    }
};



class ComparerLS {
    constructor() {
        this.countriesToCompare = [];
        this.lsKey = 'comparatorLS';
        var lsdata = window.localStorage.getItem('comparatorLS');
        if (lsdata) {
            this.countriesToCompare = JSON.parse(lsdata);
        }
    }
    addLS(value) {
        this.countriesToCompare.slice(0, 3);
        value.idx = this.countriesToCompare.length;
        this.countriesToCompare.push(value);

    }
    setLS(values) {
        this.countriesToCompare = values;
        window.localStorage.setItem(this.lsKey, JSON.stringify(values));
    }
    getLS() {
        return this.countriesToCompare;
    }
    removeLS(slug) {
        if (this.countriesToCompare.length) {
            let idx = -1;
            for (let i = 0; i < this.countriesToCompare.length; i++) {
                if (this.countriesToCompare[i].slug == slug) {
                    idx = i;
                    break;
                }
            }
            if (idx > -1) {
                this.countriesToCompare.splice(idx, 1);
                this.setLS(this.countriesToCompare);
            }
        }
    }
}